/**
 * Shared types between frontend and backend
 */

export type ShareFormat = 'md' | 'mdc'

export const SHARE_FORMATS: ShareFormat[] = ['md', 'mdc']

export const FORMAT_LABELS: Record<ShareFormat, string> = {
  'md': 'Markdown',
  'mdc': 'MDC (Markdown Components)',
}

export interface ShareMetadata {
  id: string
  createdAt: number
  expiresAt: number
  burnAfterRead: boolean
  consumedAt: number | null
  revokedAt: number | null
  viewCount: number
  isModifiable: boolean
  updatedAt: number | null
  filename: string
  rawSize: number
  encryptedSize: number
  folderPath: string
  tags: string | null
  format: ShareFormat
}

export interface CryptoParams {
  cipher: string
  nonce: string
  wrappedCek: string
  kdfSalt: string
  kdfParams: string
  wrappedCekApiKey?: string  // CEK wrapped with API key-derived key (for owner)
  kdfSaltApiKey?: string     // Salt for API key KDF
}

export interface CreateShareRequest {
  encryptedBlob: string
  wrappedCek: string
  nonce: string
  kdfSalt: string
  kdfParams: string
  cipher: string
  expiresIn: string
  burnAfterRead: boolean
  isModifiable: boolean
  filename?: string
  wrappedCekApiKey?: string  // CEK wrapped with API key-derived key
  kdfSaltApiKey?: string     // Salt for API key KDF
  rawSize: number
  encryptedSize: number
  folderPath?: string
  tags?: string
  format?: ShareFormat
}

export interface CreateShareResponse {
  shareId: string
  managementToken: string
  expiresAt: number
  filename: string
  format: ShareFormat
}

export type ExpiryOption = '1h' | '12h' | '1d' | '3d' | '7d' | '30d' | '90d' | '180d' | '1y' | 'never'

export const EXPIRY_LABELS: Record<ExpiryOption, string> = {
  '1h': '1 hour',
  '12h': '12 hours',
  '1d': '1 day',
  '3d': '3 days',
  '7d': '7 days',
  '30d': '30 days',
  '90d': '90 days',
  '180d': '180 days',
  '1y': '1 year',
  'never': 'Never',
}

export type CipherType = 'AES-256-GCM' | 'NONE'

export interface SecurityOptions {
  expiresIn: string
  burnAfterRead: boolean
  isModifiable: boolean
}
